import { InfoIcon } from 'lucide-react';
import { cn } from '@tinct/core-utils';

export type LinkedinAdsTrackingCalloutProps = {
  className?: string;
};

const Code = ({ children }: { children: React.ReactNode }) => (
  <code className="rounded bg-muted px-1 py-0.5 font-mono text-xs">{children}</code>
);

/**
 * One-time Campaign Manager setup that puts the LinkedIn campaign id on every
 * ad click, so the edge can pick the matching page variant. Shown on the
 * LinkedIn Ads integration page and in the publish step of ads campaigns —
 * same words in both places.
 */
export function LinkedinAdsTrackingCallout({ className }: LinkedinAdsTrackingCalloutProps) {
  return (
    <div
      data-slot="linkedin-ads-tracking-callout"
      className={cn(
        'flex gap-3 rounded-xl border border-border bg-muted/40 px-4 py-3 text-sm text-muted-foreground',
        className,
      )}
    >
      <InfoIcon className="mt-0.5 size-4 shrink-0 text-foreground" />
      <div className="flex flex-col gap-1">
        <p className="font-medium text-foreground">
          One-time setup: add the LinkedIn tracking parameter
        </p>
        <p>
          In Campaign Manager, add the dynamic tracking parameter{' '}
          <Code>tinct_ad = CAMPAIGN_ID</Code> at the ad-account level (Account
          settings → tracking / dynamic UTM parameters); LinkedIn then appends{' '}
          <Code>?tinct_ad=&lt;campaign id&gt;</Code> to every ad click. Campaign-level
          works too. Not applied to Conversation Ads / Message Ads.
        </p>
      </div>
    </div>
  );
}
